const SECTIONS = [
  {
    id: "introduction",
    title: "Introduction",
    blocks: [
      { t: "p", x: "Welcome to BurmeseHub.com (\"BurmeseHub,\" \"we,\" \"us,\" or \"our\")." },
      { t: "p", x: "BurmeseHub is an online business and community directory connecting Burmese-owned businesses, professionals, organizations, and communities across the United States." },
      { t: "p", x: "Our mission is to make it easier for people to discover local businesses, connect with trusted services, explore opportunities, and support the growth of the Burmese community." },
      { t: "p", x: "These Terms of Service (\"Terms\") govern your access to and use of our website, www.burmesehub.com, and related services." },
      { t: "p", x: "By accessing or using BurmeseHub, you agree to these Terms. If you do not agree, please discontinue use of our services." },
    ],
  },
  {
    id: "our-services",
    title: "Our Services",
    blocks: [
      { t: "p", x: "BurmeseHub provides an online platform where visitors may discover:" },
      { t: "ul", items: ["Burmese-owned businesses and professional services", "Restaurants, grocery stores, and local establishments", "Real estate and other professional services", "Community organizations and resources", "Employment opportunities", "Community events and announcements", "Other business and community-related information"] },
      { t: "p", x: "Where available, users may submit business listings, manage their information, and interact with platform features." },
      { t: "p", x: "BurmeseHub primarily serves as an information and connection platform. Unless expressly stated otherwise, we are not a party to transactions or agreements between visitors and listed businesses." },
    ],
  },
  {
    id: "eligibility",
    title: "Eligibility and User Accounts",
    blocks: [
      { t: "p", x: "You may browse publicly available content in accordance with applicable law." },
      { t: "p", x: "Users submitting listings or creating business accounts must be at least 18 years old or otherwise have the legal authority required to act on behalf of a business or organization." },
      { t: "p", x: "When creating an account, you agree to provide accurate information and maintain the security of your login credentials." },
      { t: "p", x: "You are responsible for activities conducted through your account, except where caused by circumstances for which we are legally responsible." },
      { t: "p", x: "We may restrict or suspend accounts associated with fraud, misuse, unauthorized activity, or violations of these Terms." },
    ],
  },
  {
    id: "business-listings",
    title: "Business Listings",
    blocks: [
      { t: "p", x: "Business owners and authorized representatives may submit businesses for inclusion in the BurmeseHub directory." },
      { t: "p", x: "By submitting a listing, you agree that:" },
      { t: "ul", items: ["The information you provide is accurate and not misleading.", "You have the authority to represent the business.", "You have the necessary rights or permissions to submit photographs, logos, and other materials.", "Contact information and business descriptions are appropriate for public display.", "Your listing complies with applicable laws and regulations.", "You will make reasonable efforts to keep your listing information current."] },
      { t: "p", x: "BurmeseHub reserves the right to review, approve, decline, edit for formatting, temporarily suspend, or remove listings that violate these Terms, applicable laws, or our publishing standards." },
      { t: "p", x: "Submission does not guarantee publication, placement, search ranking, or customer inquiries." },
      { t: "h", x: "Free Business Listings" },
      { t: "p", x: "BurmeseHub currently offers free business listing submissions." },
      { t: "p", x: "If optional paid advertising, featured placements, or premium services become available, applicable prices and additional terms will be disclosed before purchase." },
      { t: "p", x: "We will not impose charges for optional paid services without appropriate authorization." },
    ],
  },
  {
    id: "accuracy",
    title: "Accuracy of Information",
    blocks: [
      { t: "p", x: "We aim to maintain a useful and reliable business directory. However, much of the information displayed on BurmeseHub may be supplied directly by business owners, authorized representatives, or other third parties." },
      { t: "p", x: "We do not guarantee the accuracy, completeness, availability, licensing status, quality, or reliability of every listed business or service." },
      { t: "p", x: "Visitors are encouraged to independently verify important details, including business credentials, prices, operating hours, availability, and professional qualifications." },
      { t: "p", x: "A business appearing on BurmeseHub does not automatically mean that it has been independently verified, certified, or endorsed by BurmeseHub." },
    ],
  },
  {
    id: "user-content",
    title: "User-Submitted Content",
    blocks: [
      { t: "p", x: "Users may submit business descriptions, photographs, logos, announcements, and other materials permitted by the platform." },
      { t: "p", x: "You retain ownership of content you submit, subject to any rights held by third parties." },
      { t: "p", x: "By submitting content for publication, you grant BurmeseHub a non-exclusive, worldwide, royalty-free license to host, reproduce, display, format, and distribute that content as reasonably necessary to operate and promote the directory and your listing." },
      { t: "p", x: "This permission continues while the content is hosted or used for authorized platform purposes, subject to applicable law and any surviving legitimate uses." },
      { t: "p", x: "You agree not to submit content that:" },
      { t: "ul", items: ["Is knowingly false, misleading, or fraudulent", "Infringes intellectual property or privacy rights", "Contains unlawful threats or harassment", "Promotes illegal products, services, or activities", "Contains malware, spam, or malicious links", "Impersonates another person or business", "Violates applicable laws or regulations"] },
      { t: "p", x: "We may moderate or remove content when reasonably necessary to maintain platform integrity and safety." },
    ],
  },
  {
    id: "reviews",
    title: "Reviews and Community Contributions",
    blocks: [
      { t: "p", x: "If BurmeseHub offers reviews, ratings, comments, or recommendations, users must submit genuine opinions based on real experiences." },
      { t: "p", x: "Fake reviews, impersonation, undisclosed paid endorsements, and manipulation of ratings are prohibited." },
      { t: "p", x: "Businesses may not use the platform to fabricate positive reviews or publish fraudulent negative reviews about competitors." },
      { t: "p", x: "We may investigate and remove content that violates our review standards, while respecting applicable consumer protections for honest feedback." },
    ],
  },
  {
    id: "advertising",
    title: "Advertising and Featured Businesses",
    blocks: [
      { t: "p", x: "BurmeseHub may offer advertising opportunities, sponsored content, or featured business placements." },
      { t: "p", x: "Paid promotions will be identified as sponsored or promotional content when necessary to avoid misleading visitors." },
      { t: "p", x: "Unless expressly stated otherwise, a paid placement does not represent an independent certification, guarantee, or recommendation of the advertised business." },
      { t: "p", x: "Separate advertising terms may apply to future promotional services." },
    ],
  },
  {
    id: "third-party",
    title: "Third-Party Businesses and Transactions",
    blocks: [
      { t: "p", x: "BurmeseHub connects visitors with independent businesses and professionals." },
      { t: "p", x: "Unless expressly identified as a service offered directly by BurmeseHub, we do not own, operate, employ, or control businesses listed in our directory." },
      { t: "p", x: "Any purchases, bookings, payments, employment arrangements, or service agreements made between visitors and third parties are generally the responsibility of those parties." },
      { t: "p", x: "BurmeseHub is not responsible for third-party products, workmanship, refunds, contractual disputes, or business conduct except where responsibility cannot legally be excluded." },
    ],
  },
  {
    id: "jobs-events",
    title: "Jobs and Community Events",
    blocks: [
      { t: "p", x: "Job postings and event announcements are provided for informational purposes." },
      { t: "p", x: "Employers and organizers are responsible for the accuracy, legality, and fulfillment of their announcements." },
      { t: "p", x: "BurmeseHub does not guarantee employment, job placement, event availability, participant safety, or the legitimacy of every opportunity listed." },
      { t: "p", x: "Users should independently verify opportunities before making payments, sharing sensitive information, or entering agreements." },
    ],
  },
  {
    id: "intellectual-property",
    title: "Intellectual Property",
    blocks: [
      { t: "p", x: "The BurmeseHub name, branding, website design, original text, graphics, and other content created or owned by BurmeseHub are protected by applicable intellectual property laws." },
      { t: "p", x: "Business names, trademarks, logos, photographs, and other materials submitted by third parties remain the property of their respective owners." },
      { t: "p", x: "You may not reproduce or commercially exploit BurmeseHub-owned content without permission, except where permitted by law." },
      { t: "p", x: "If you believe that content on BurmeseHub infringes your intellectual property rights, please contact us with sufficient information to identify the material and your rights." },
    ],
  },
  {
    id: "prohibited",
    title: "Prohibited Activities",
    blocks: [
      { t: "p", x: "Users may not:" },
      { t: "ul", items: ["Attempt unauthorized access to the website, accounts, or systems", "Upload malicious software or harmful code", "Use the platform to conduct fraud or impersonation", "Collect personal information through unauthorized scraping or harvesting", "Interfere with the website's security or performance", "Publish illegal or abusive content", "Misrepresent business ownership, credentials, or licensing", "Use BurmeseHub branding to falsely imply an official partnership"] },
      { t: "p", x: "We may take appropriate action in response to suspected violations." },
    ],
  },
  {
    id: "privacy",
    title: "Privacy",
    blocks: [
      { t: "p", x: "Your use of BurmeseHub is also subject to our Privacy Policy, which explains how we collect, process, and protect personal information." },
      { t: "p", x: "Please review our Privacy Policy at:" },
      { t: "link", x: "https://www.burmesehub.com/privacy-policy", href: "/privacy-policy", testid: "terms-privacy-link" },
    ],
  },
  {
    id: "disclaimer",
    title: "Disclaimer of Warranties",
    blocks: [
      { t: "p", x: "BurmeseHub is provided on an \"as available\" basis." },
      { t: "p", x: "To the maximum extent permitted by applicable law, we disclaim warranties not expressly provided, including implied warranties of merchantability, fitness for a particular purpose, and non-infringement." },
      { t: "p", x: "We do not guarantee uninterrupted access, error-free operation, specific business results, or the accuracy of third-party content." },
      { t: "p", x: "Nothing in these Terms excludes warranties or consumer protections that cannot lawfully be excluded." },
    ],
  },
  {
    id: "liability",
    title: "Limitation of Liability",
    blocks: [
      { t: "p", x: "To the maximum extent permitted by applicable law, BurmeseHub and its operators will not be liable for indirect, incidental, special, or consequential damages arising from the use of our platform, including lost business opportunities or disputes involving independent third parties." },
      { t: "p", x: "These limitations do not apply where prohibited by law and do not exclude liability that cannot legally be limited." },
    ],
  },
  {
    id: "removal-termination",
    title: "Listing Removal and Account Termination",
    blocks: [
      { t: "p", x: "Business owners or authorized representatives may request listing updates or removal through our contact channels." },
      { t: "p", x: "We may suspend or remove listings or accounts that violate these Terms or create legitimate safety, legal, or security concerns." },
      { t: "p", x: "Users may discontinue use of the platform at any time." },
      { t: "p", x: "Account or listing removal does not necessarily result in immediate deletion of content retained by search engines, third parties, or legally required records." },
    ],
  },
  {
    id: "changes",
    title: "Changes to Our Services and Terms",
    blocks: [
      { t: "p", x: "We may update, improve, suspend, or discontinue website features from time to time." },
      { t: "p", x: "We may also revise these Terms to reflect operational, legal, or security changes." },
      { t: "p", x: "Updated Terms will be posted with a revised effective date. Where required by law, we will provide additional notice or obtain consent before material changes take effect." },
    ],
  },
  {
    id: "governing-law",
    title: "Governing Law",
    blocks: [
      { t: "p", x: "These Terms are intended to be governed by the applicable laws of [Insert the U.S. state governing the website operator], without overriding mandatory consumer protections or other laws that apply to users." },
      { t: "p", x: "Any dispute-resolution or court-venue provisions must comply with applicable law." },
    ],
  },
  {
    id: "contact",
    title: "Contact Us",
    blocks: [
      { t: "p", x: "For questions about these Terms, business listings, intellectual property concerns, or other matters, please contact:" },
      { t: "p", x: "BurmeseHub.com" },
      { t: "link", label: "Website:", x: "https://www.burmesehub.com", href: "/", testid: "terms-contact-website" },
      { t: "link", label: "Email:", x: "admin@burmesehub.com", href: "mailto:admin@burmesehub.com", testid: "terms-contact-email" },
      { t: "link", label: "Contact Page:", x: "https://www.burmesehub.com/contact", href: "/contact", testid: "terms-contact-page" },
      { t: "motto", x: "BurmeseHub.com — Find. Connect. Belong." },
      { t: "p", x: "Connecting businesses. Supporting communities. Growing together." },
    ],
  },
];

export default SECTIONS;
